import { createStyles, Theme } from '@material-ui/core/styles';

const sideBarWidth = 240;
const sideBarLargeWidth = 318;

const standardLayoutStyles = ({
  spacing, breakpoints, colors, borders, shadow,
}: Theme) => createStyles({
  main: {
    background: colors.layout.backgroundSecondary,
    padding: `0 ${spacing(6)}px ${spacing(3)}px 0`,
  },
  body: {
    background: colors.layout.backgroundPrimary,
    borderRadius: borders.radius3,
    paddingTop: spacing(6),
    paddingBottom: spacing(6),
    boxShadow: shadow.dropShadow400,
    minHeight: `calc(100vh - ${spacing(13)}px)`,
  },
  h1: {
    color: colors.text.accent,
  },
  sidebar: {
    width: sideBarWidth,
    height: `calc(100vh - ${spacing(3)}px)`,
    position: 'fixed',
    [breakpoints.up('lg')]: {
      width: sideBarLargeWidth,
    },
  },
  sidebarContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  logo: {
    paddingTop: spacing(4),
    paddingBottom: spacing(4),
    marginBottom: spacing(4),
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      width: '100%',
      borderBottom: `2px solid ${colors.layout.divider300}`,
    },
  },
  navLinks: {
    flex: 1,
  },
  link: {
    lineHeight: 0,
    marginBottom: spacing(4),
  },
  content: {
    width: `calc(100% - ${sideBarWidth}px)`,
    marginLeft: sideBarWidth,
    [breakpoints.up('lg')]: {
      width: `calc(100% - ${sideBarLargeWidth}px)`,
      marginLeft: sideBarLargeWidth,
    },
  },
  title: {
    marginBottom: spacing(6),
    color: colors.text.accent,
  },
  description: {
    color: colors.text.primary,
    width: spacing(100),
    marginTop: spacing(3),
  },
  supportLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(1),
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export default standardLayoutStyles;
